/**
 * error messages to be shown in invoicing process
 */
export enum InvoiceErrorMessage {
  ARTICULATOR_BUNDLE = 'Cases with metal articulators cannot be bundled with other cases. Invoice this case separately.',
}
